import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: "loginForm" }
const _hoisted_2 = ["aria-describedby", "aria-invalid"]
const _hoisted_3 = ["aria-describedby", "aria-invalid"]
const _hoisted_4 = ["value", "disabled"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: "forgotPasswordForm" }
const _hoisted_7 = { id: "ForgotPassword" }
const _hoisted_8 = ["aria-describedby", "aria-invalid"]
const _hoisted_9 = ["value", "disabled"]
const _hoisted_10 = { key: "getVerificationCodeForm" }
const _hoisted_11 = ["aria-describedby", "aria-invalid"]
const _hoisted_12 = ["value", "disabled"]
const _hoisted_13 = { key: "emailVerificationForm" }
const _hoisted_14 = ["aria-describedby", "aria-invalid"]
const _hoisted_15 = ["value", "disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { key: "loginSuccessView" }
const _hoisted_18 = { key: "accountLockedView" }
const _hoisted_19 = { id: "AccountLock" }
const _hoisted_20 = { key: "logoutSuccessView" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.getClass('modal-backdrop') + ' ' + _ctx.getClass('modal-backdrop--custom'))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.getClass('modal') + ' ' + _ctx.getClass('modal--custom')),
      role: "dialog",
      "aria-modal": "true",
      "aria-label": "Admin Login modal",
      "aria-describedby": "modalDescription",
      ref: "login_modal"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.getClass('modal-header'))
      }, [
        _createCommentVNode(" <button type=\"button\" class=\"btn-back\" aria-label=\"Go back to Login page\"\r\n                title=\"Go back\" v-if=\"currentStep === LoginActionEnum.FORGOT_PASSWORD\"\r\n                @click=\"goBack\">\r\n                <span aria-hidden=\"true\">&lt;</span>\r\n            </button> "),
        _cache[19] || (_cache[19] = _createElementVNode("span", { "aria-hidden": "true" }, " ", -1 /* HOISTED */)),
        _withDirectives(_createElementVNode("button", {
          type: "button",
          class: _normalizeClass(_ctx.getClass('btn-close')),
          "aria-label": "Close modal",
          onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
          title: "Close modal"
        }, _cache[18] || (_cache[18] = [
          _createElementVNode("span", { "aria-hidden": "true" }, "×", -1 /* HOISTED */)
        ]), 2 /* CLASS */), [
          [_vShow, _ctx.currentStep !== _ctx.LoginActionEnum.LOGIN_SUCCESS && _ctx.currentStep !== _ctx.LoginActionEnum.LOGOUT_SUCCESS]
        ])
      ], 2 /* CLASS */),
      _createElementVNode("section", {
        class: _normalizeClass(_ctx.getClass('modal-body') + ' ' + _ctx.getClass('modal-body--custom')),
        id: "modalDescription"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.getClass('multi-step-form'))
        }, [
          _createCommentVNode(" LOGIN "),
          _withDirectives(_createElementVNode("section", _hoisted_1, [
            _createElementVNode("form", {
              onSubmit: _cache[4] || (_cache[4] = _withModifiers((...args) => (_ctx.doLogin && _ctx.doLogin(...args)), ["prevent"])),
              class: _normalizeClass(_ctx.getClass('form-inline'))
            }, [
              _createElementVNode("div", {
                id: "LoginForm",
                class: _normalizeClass(_ctx.getClass('login-form'))
              }, [
                _createCommentVNode(" Row 1 "),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('content-center '))
                }, [
                  _createElementVNode("p", {
                    class: _normalizeClass(_ctx.getClass('small-text '))
                  }, "Please enter your e-mail address or username and password.", 2 /* CLASS */)
                ], 2 /* CLASS */),
                _createCommentVNode(" Row 2 "),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('pb-16 '))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.getClass('form-element '))
                  }, [
                    _createElementVNode("label", {
                      for: "loginEmail",
                      class: _normalizeClass(_ctx.getClass('form-label'))
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.getClass('label-text'))
                      }, "Email", 2 /* CLASS */),
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.getClass('required-mark')),
                        "aria-hidden": "true"
                      }, "*", 2 /* CLASS */)
                    ], 2 /* CLASS */),
                    _withDirectives(_createElementVNode("input", {
                      id: "loginEmail",
                      maxlength: "500",
                      name: "EmailUser",
                      class: _normalizeClass(_ctx.getClass('form-input ')),
                      placeholder: "Email",
                      type: "text",
                      value: "",
                      required: "",
                      oninvalid: "this.setCustomValidity('E-Mail or Username is required.')",
                      oninput: "this.setCustomValidity('')",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.loginForm.email) = $event)),
                      tabindex: "0",
                      spellcheck: "false",
                      autocomplete: "username",
                      "aria-required": "true",
                      "aria-describedby": _ctx.loginForm.errors ? 'loginFormError' : null,
                      "aria-invalid": !!_ctx.loginForm.errors
                    }, null, 10 /* CLASS, PROPS */, _hoisted_2), [
                      [
                        _vModelText,
                        _ctx.loginForm.email,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.getClass('login-form-validation-error ') + _ctx.getClass('field-validation-valid ') + _ctx.getClass('no-display '))
                    }, " E-Mail or Username is required. ", 2 /* CLASS */)
                  ], 2 /* CLASS */)
                ], 2 /* CLASS */),
                _createCommentVNode(" Row 3 "),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getClass('form-row '))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.getClass('form-element '))
                  }, [
                    _createElementVNode("label", {
                      for: "Password",
                      class: _normalizeClass(_ctx.getClass('form-label'))
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.getClass('label-text'))
                      }, "Password", 2 /* CLASS */),
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.getClass('required-mark')),
                        "aria-hidden": "true"
                      }, "*", 2 /* CLASS */)
                    ], 2 /* CLASS */),
                    _withDirectives(_createElementVNode("input", {
                      id: "Password",
                      maxlength: "100",
                      name: "Password",
                      class: _normalizeClass(_ctx.getClass('form-input ')),
                      placeholder: "Password",
                      type: "password",
                      required: "",
                      oninvalid: "this.setCustomValidity('Password is required.')",
                      oninput: "this.setCustomValidity('')",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.loginForm.password) = $event)),
                      tabindex: "0",
                      spellcheck: "false",
                      autocomplete: "current-password",
                      "aria-required": "true",
                      "aria-describedby": _ctx.loginForm.errors ? 'loginFormError' : null,
                      "aria-invalid": !!_ctx.loginForm.errors
                    }, null, 10 /* CLASS, PROPS */, _hoisted_3), [
                      [
                        _vModelText,
                        _ctx.loginForm.password,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.getClass('login-form-validation-error ') + _ctx.getClass('field-validation-valid ') + _ctx.getClass('no-display '))
                    }, " Password is required. ", 2 /* CLASS */)
                  ], 2 /* CLASS */)
                ], 2 /* CLASS */),
                _createCommentVNode(" Row 4 "),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getClass('form-row '))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.getClass('form-element '))
                  }, [
                    _createElementVNode("a", {
                      id: "hlForgotPassword",
                      class: _normalizeClass(_ctx.getClass('secondary-link ') + _ctx.getClass('content-right ')),
                      href: "javascript:void(0)",
                      style: {"width":"100%"},
                      onClick: _cache[3] || (_cache[3] = _withModifiers((...args) => (_ctx.showForgotPassword && _ctx.showForgotPassword(...args)), ["prevent"]))
                    }, " Forgot Password", 2 /* CLASS */)
                  ], 2 /* CLASS */)
                ], 2 /* CLASS */),
                _createCommentVNode(" Row 5 "),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getClass('form-row '))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.getClass('form-element '))
                  }, [
                    _createCommentVNode(" <button type=\"submit\"\r\n                                        :class=\"getClass('btn-login ') + getClass('btn-block ') + getClass('btn-primary ')\"\r\n                                        @click=\"doLogin\">Login</button> "),
                    _createElementVNode("input", {
                      type: "submit",
                      value: !_ctx.loginForm.isLoading ? 'Login' : 'Logging in...',
                      disabled: _ctx.loginForm.isLoading,
                      class: _normalizeClass(_ctx.getClass('btn-login ') + _ctx.getClass('btn-block ') + _ctx.getClass('btn-primary '))
                    }, null, 10 /* CLASS, PROPS */, _hoisted_4)
                  ], 2 /* CLASS */)
                ], 2 /* CLASS */),
                _createCommentVNode(" Row 6 "),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getClass('form-row ')),
                  style: {"margin-top":"25px"}
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.getClass('form-element ') + _ctx.getClass('form-footer ') + _ctx.getClass('content-center '))
                  }, " © " + _toDisplayString(new Date().getFullYear()) + " Satisfi Labs Inc. All rights reserved. ", 3 /* TEXT, CLASS */)
                ], 2 /* CLASS */),
                (!!_ctx.loginForm.errors)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('pb-0'))
                    }, [
                      _createElementVNode("span", {
                        id: "loginFormError",
                        class: _normalizeClass(_ctx.getClass('content-center ') + _ctx.getClass('login-form-validation-error ') + _ctx.getClass('field-validation-error ')),
                        innerHTML: _ctx.loginForm.errors
                      }, null, 10 /* CLASS, PROPS */, _hoisted_5)
                    ], 2 /* CLASS */))
                  : _createCommentVNode("v-if", true)
              ], 2 /* CLASS */)
            ], 34 /* CLASS, NEED_HYDRATION */)
          ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.currentStep === _ctx.LoginActionEnum.LOGIN]
          ]),
          _createCommentVNode(" Forgot Password "),
          _withDirectives(_createElementVNode("section", _hoisted_6, [
            _createElementVNode("form", {
              onSubmit: _cache[7] || (_cache[7] = _withModifiers((...args) => (_ctx.requestPasswordReset && _ctx.requestPasswordReset(...args)), ["prevent"])),
              class: _normalizeClass(_ctx.getClass('form-inline'))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createCommentVNode(" Row 1 "),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('content-center ') + _ctx.getClass('pb-16 '))
                }, [
                  _createElementVNode("p", {
                    class: _normalizeClass(_ctx.getClass('large-text '))
                  }, "Forgot Password", 2 /* CLASS */)
                ], 2 /* CLASS */),
                _createCommentVNode(" Row 2 "),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getClass('form-row '))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.getClass('form-element '))
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      id: "forgotEmail",
                      maxlength: "500",
                      name: "EmailUser",
                      class: _normalizeClass(_ctx.getClass('form-input ')),
                      placeholder: "Email (required)",
                      type: "text",
                      value: "",
                      required: "",
                      oninvalid: "this.setCustomValidity('E-Mail or Username is required.')",
                      oninput: "this.setCustomValidity('')",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.forgotPwdForm.email) = $event)),
                      tabindex: "0",
                      spellcheck: "false",
                      autocomplete: "username",
                      "aria-required": "true",
                      "aria-describedby": _ctx.forgotPwdForm.error ? 'forgotEmailError' : null,
                      "aria-invalid": !!_ctx.forgotPwdForm.error
                    }, null, 10 /* CLASS, PROPS */, _hoisted_8), [
                      [
                        _vModelText,
                        _ctx.forgotPwdForm.email,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    (!!_ctx.forgotPwdForm.error)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          id: "forgotEmailError",
                          class: _normalizeClass(_ctx.getClass('content-center ') + _ctx.getClass('login-form-validation-error ') + _ctx.getClass('field-validation-error '))
                        }, _toDisplayString(_ctx.forgotPwdForm.error), 3 /* TEXT, CLASS */))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */)
                ], 2 /* CLASS */),
                _createCommentVNode(" Row 3 "),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getClass('form-row '))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.getClass('form-element '))
                  }, [
                    _createElementVNode("input", {
                      type: "submit",
                      value: !_ctx.forgotPwdForm.isLoading ? 'Request Password Reset' : 'Requesting...',
                      disabled: _ctx.forgotPwdForm.isLoading,
                      class: _normalizeClass(_ctx.getClass('btn-login ') + _ctx.getClass('btn-block ') + _ctx.getClass('btn-primary '))
                    }, null, 10 /* CLASS, PROPS */, _hoisted_9)
                  ], 2 /* CLASS */)
                ], 2 /* CLASS */),
                _createCommentVNode(" Row 4 "),
                (!!_ctx.forgotPwdForm.message)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('content-center '))
                    }, [
                      _createElementVNode("p", {
                        class: _normalizeClass(_ctx.getClass('small-text ') + _ctx.getClass('action-success '))
                      }, _toDisplayString(_ctx.forgotPwdForm.message), 3 /* TEXT, CLASS */)
                    ], 2 /* CLASS */))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Row 5 "),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('pb-0 ') + _ctx.getClass('content-center '))
                }, [
                  _createElementVNode("a", {
                    class: _normalizeClass(_ctx.getClass('goback-link ')),
                    href: "javascript:void();",
                    onClick: _cache[6] || (_cache[6] = _withModifiers((...args) => (_ctx.goBack && _ctx.goBack(...args)), ["prevent"]))
                  }, "← Back to Login", 2 /* CLASS */)
                ], 2 /* CLASS */)
              ])
            ], 34 /* CLASS, NEED_HYDRATION */)
          ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.currentStep === _ctx.LoginActionEnum.FORGOT_PASSWORD]
          ]),
          _createCommentVNode(" Get Verification Code "),
          _withDirectives(_createElementVNode("section", _hoisted_10, [
            _createElementVNode("form", {
              onSubmit: _cache[10] || (_cache[10] = _withModifiers((...args) => (_ctx.moveToVerifyEmail && _ctx.moveToVerifyEmail(...args)), ["prevent"])),
              class: _normalizeClass(_ctx.getClass('form-inline'))
            }, [
              _createElementVNode("div", {
                id: "TwoStepVerification",
                class: _normalizeClass(_ctx.getClass('mfa-container-main'))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('large-text ') + _ctx.getClass('content-center '))
                }, " Two-Step Verification ", 2 /* CLASS */),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('small-text2 ') + _ctx.getClass('content-center '))
                }, " In order to keep your account safe, we want to make sure it's really you. Choose how you want to verify ", 2 /* CLASS */),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getClass('form-row '))
                }, [
                  _createElementVNode("label", {
                    for: "chkEmail",
                    class: _normalizeClass(_ctx.getClass('control-label ') + _ctx.getClass('content-right '))
                  }, " Get verification code by Email ", 2 /* CLASS */),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.getClass('form-checkbox'))
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "chkEmail",
                      required: "",
                      class: _normalizeClass(_ctx.getClass('checkbox-control')),
                      oninvalid: "this.setCustomValidity('Please select a way to verify your account')",
                      oninput: "this.setCustomValidity('')",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.getVerificationCodeForm.isEmail) = $event)),
                      "aria-required": "true",
                      "aria-describedby": _ctx.getVerificationCodeForm.error ? 'getVerificationCodeError' : null,
                      "aria-invalid": !!_ctx.getVerificationCodeForm.error
                    }, null, 10 /* CLASS, PROPS */, _hoisted_11), [
                      [
                        _vModelCheckbox,
                        _ctx.getVerificationCodeForm.isEmail,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ], 2 /* CLASS */)
                ], 2 /* CLASS */),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getClass('form-row '))
                }, [
                  _createElementVNode("input", {
                    type: "submit",
                    value: !_ctx.getVerificationCodeForm.isLoading ? 'NEXT' : 'Loading...',
                    disabled: _ctx.getVerificationCodeForm.isLoading,
                    class: _normalizeClass(_ctx.getClass('btn-login ') + _ctx.getClass('btn-block ') + _ctx.getClass('btn-primary '))
                  }, null, 10 /* CLASS, PROPS */, _hoisted_12)
                ], 2 /* CLASS */),
                (!!_ctx.getVerificationCodeForm.error)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('content-center '))
                    }, [
                      _createElementVNode("span", {
                        id: "getVerificationCodeError",
                        class: _normalizeClass(_ctx.getClass('login-form-validation-error ') + _ctx.getClass('field-validation-error '))
                      }, _toDisplayString(_ctx.getVerificationCodeForm.error), 3 /* TEXT, CLASS */)
                    ], 2 /* CLASS */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('content-center '))
                }, [
                  _createElementVNode("a", {
                    class: _normalizeClass(_ctx.getClass('goback-link ')),
                    href: "javascript:void();",
                    onClick: _cache[9] || (_cache[9] = _withModifiers((...args) => (_ctx.goBack && _ctx.goBack(...args)), ["prevent"]))
                  }, "Login to a different account?", 2 /* CLASS */)
                ], 2 /* CLASS */)
              ], 2 /* CLASS */)
            ], 34 /* CLASS, NEED_HYDRATION */)
          ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.currentStep === _ctx.LoginActionEnum.GET_CODE]
          ]),
          _createCommentVNode(" Email Verification / Enter Code "),
          _withDirectives(_createElementVNode("section", _hoisted_13, [
            _createElementVNode("form", {
              onSubmit: _cache[15] || (_cache[15] = _withModifiers((...args) => (_ctx.verifyOTP && _ctx.verifyOTP(...args)), ["prevent"])),
              class: _normalizeClass(_ctx.getClass('form-inline'))
            }, [
              _createElementVNode("div", {
                id: "EmailVerification",
                class: _normalizeClass(_ctx.getClass('mfa-container-main'))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('large-text ') + _ctx.getClass('content-center '))
                }, " Two-Step Verification ", 2 /* CLASS */),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('small-text2 ') + _ctx.getClass('content-center '))
                }, " Please Enter the 6 digit code we have sent to your login email address ", 2 /* CLASS */),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('content-center '))
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "otpText",
                    pattern: "\\d*",
                    class: _normalizeClass(_ctx.getClass('form-otp-text ')  + _ctx.getClass('numbersOnly ')),
                    maxlength: "6",
                    required: "",
                    onKeypress: _cache[11] || (_cache[11] = (...args) => (_ctx.numbersOnly && _ctx.numbersOnly(...args))),
                    oninvalid: "this.setCustomValidity('Please enter OTP!')",
                    oninput: "this.setCustomValidity('')",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((_ctx.emailVerificationForm.otp) = $event)),
                    tabindex: "0",
                    spellcheck: "false",
                    autocomplete: "one-time-code",
                    "aria-required": "true",
                    "aria-describedby": _ctx.emailVerificationForm.error ? 'otpError' : null,
                    "aria-invalid": !!_ctx.emailVerificationForm.error
                  }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_14), [
                    [
                      _vModelText,
                      _ctx.emailVerificationForm.otp,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ], 2 /* CLASS */),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getClass('form-row '))
                }, [
                  _createElementVNode("input", {
                    type: "submit",
                    value: !_ctx.emailVerificationForm.isLoading ? 'Submit Code' : 'Submitting...',
                    disabled: _ctx.emailVerificationForm.isLoading,
                    class: _normalizeClass(_ctx.getClass('btn-login ') + _ctx.getClass('btn-block ') + _ctx.getClass('btn-primary '))
                  }, null, 10 /* CLASS, PROPS */, _hoisted_15)
                ], 2 /* CLASS */),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('mfa-checkbox-div '))
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "rememberMe",
                    class: _normalizeClass(_ctx.getClass('rememberMe ') + _ctx.getClass('checkbox-control ')),
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((_ctx.emailVerificationForm.rememberMe) = $event))
                  }, null, 2 /* CLASS */), [
                    [
                      _vModelCheckbox,
                      _ctx.emailVerificationForm.rememberMe,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createElementVNode("label", {
                    for: "rememberMe",
                    class: _normalizeClass(_ctx.getClass('mb-0'))
                  }, "Remember me on this computer", 2 /* CLASS */)
                ], 2 /* CLASS */),
                (!!_ctx.emailVerificationForm.error)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('content-center '))
                    }, [
                      _createElementVNode("span", {
                        id: "otpError",
                        class: _normalizeClass(_ctx.getClass('login-form-validation-error ') + _ctx.getClass('field-validation-error '))
                      }, _toDisplayString(_ctx.emailVerificationForm.error), 3 /* TEXT, CLASS */)
                    ], 2 /* CLASS */))
                  : _createCommentVNode("v-if", true),
                (!!_ctx.emailVerificationForm.message)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('content-center '))
                    }, [
                      _createElementVNode("p", {
                        class: _normalizeClass(_ctx.getClass('small-text ') + _ctx.getClass('action-success '))
                      }, _toDisplayString(_ctx.emailVerificationForm.message), 3 /* TEXT, CLASS */)
                    ], 2 /* CLASS */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('content-center '))
                }, [
                  _createElementVNode("a", {
                    class: _normalizeClass(_ctx.getClass('goback-link ')),
                    href: "javascript:void();",
                    disabled: _ctx.emailVerificationForm.isEmailLoading,
                    onClick: _cache[14] || (_cache[14] = _withModifiers((...args) => (_ctx.requestAnotherEmail && _ctx.requestAnotherEmail(...args)), ["prevent"]))
                  }, " Didn't receive an email? Click here to request another", 10 /* CLASS, PROPS */, _hoisted_16)
                ], 2 /* CLASS */)
              ], 2 /* CLASS */)
            ], 34 /* CLASS, NEED_HYDRATION */)
          ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.currentStep === _ctx.LoginActionEnum.ENTER_CODE]
          ]),
          _createCommentVNode(" Login Success "),
          _withDirectives(_createElementVNode("section", _hoisted_17, [
            _createElementVNode("div", {
              id: "LoginSuccess",
              class: _normalizeClass(_ctx.getClass('login-success'))
            }, [
              _createCommentVNode(" Row 1 "),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('content-center '))
              }, [
                _createElementVNode("p", {
                  class: _normalizeClass(_ctx.getClass('large-text '))
                }, "Login Successful!", 2 /* CLASS */)
              ], 2 /* CLASS */),
              _createCommentVNode(" Row 2 "),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('content-center '))
              }, [
                _createElementVNode("p", {
                  class: _normalizeClass(_ctx.getClass('small-text '))
                }, " Administrative features are now active for this session.", 2 /* CLASS */)
              ], 2 /* CLASS */),
              _createCommentVNode(" Row 3 "),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('pb-0 '))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getClass('form-element '))
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(_ctx.getClass('btn-login ') + _ctx.getClass('btn-block ') + _ctx.getClass('btn-primary ')),
                    onClick: _cache[16] || (_cache[16] = $event => (_ctx.continueChatAsAdmin()))
                  }, "Continue", 2 /* CLASS */)
                ], 2 /* CLASS */)
              ], 2 /* CLASS */)
            ], 2 /* CLASS */)
          ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.currentStep === _ctx.LoginActionEnum.LOGIN_SUCCESS]
          ]),
          _createCommentVNode(" Account Locked "),
          _withDirectives(_createElementVNode("section", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('content-center '))
              }, [
                _createElementVNode("p", {
                  class: _normalizeClass(_ctx.getClass('error-large-text '))
                }, "Account Locked", 2 /* CLASS */)
              ], 2 /* CLASS */),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('content-center '))
              }, [
                _createElementVNode("p", {
                  class: _normalizeClass(_ctx.getClass('small-text2'))
                }, _cache[20] || (_cache[20] = [
                  _createTextVNode("Too many failed attempts were made to access your account. Please get in touch with an administrator on your account or submit a request ticket to our support team "),
                  _createElementVNode("a", {
                    target: "_blank",
                    style: {"color":"#337ab7","text-decoration":"underline","font-weight":"bold"},
                    href: "https://satisfi-labs.atlassian.net/servicedesk/customer/portal/10/group/39/create/167",
                    rel: "noopener noreferrer"
                  }, "here", -1 /* HOISTED */)
                ]), 2 /* CLASS */)
              ], 2 /* CLASS */)
            ])
          ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.currentStep === _ctx.LoginActionEnum.ACCOUNT_LOCKED]
          ]),
          _createCommentVNode(" Logout Success "),
          _withDirectives(_createElementVNode("section", _hoisted_20, [
            _createElementVNode("div", {
              id: "LogoutSuccess",
              class: _normalizeClass(_ctx.getClass('login-success'))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('content-center '))
              }, [
                _createElementVNode("p", {
                  class: _normalizeClass(_ctx.getClass('large-text '))
                }, "Logged Out", 2 /* CLASS */)
              ], 2 /* CLASS */),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('content-center '))
              }, [
                _createElementVNode("p", {
                  class: _normalizeClass(_ctx.getClass('small-text '))
                }, " Administrative features are no longer active.", 2 /* CLASS */)
              ], 2 /* CLASS */),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.getClass('form-row ') + _ctx.getClass('pb-0 '))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.getClass('form-element '))
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(_ctx.getClass('btn-login ') + _ctx.getClass('btn-block ') + _ctx.getClass('btn-primary ')),
                    onClick: _cache[17] || (_cache[17] = $event => (_ctx.continueChatAsNonAdmin()))
                  }, "Continue", 2 /* CLASS */)
                ], 2 /* CLASS */)
              ], 2 /* CLASS */)
            ], 2 /* CLASS */)
          ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.currentStep === _ctx.LoginActionEnum.LOGOUT_SUCCESS]
          ])
        ], 2 /* CLASS */)
      ], 2 /* CLASS */)
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}